import React, {Component} from 'react';
import { Link } from "react-router-dom";
import { Tooltip } from 'reactstrap';
import ToggleSwitch from "../common/input/ToggleSwitch";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import {get} from 'lodash';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";

class HealthPlanNotifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSupportTooltip: false,
            showAuthTooltip: false,
            showOtherTooltip: false,
            isSupportEmailEnabled: false,
            isSupportTextEnabled: false,
            isAuthEmailEnabled: false,
            isCertMailEnabled: false,
            isCertEmailEnabled: false,
            isExpMailEnabled: false,
            isExpEmailEnabled: false,
            isOthersMailEnabled: false,
            isOthersEmailEnabled: false,
            shouldLoadData: true,
            showLoader: true
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Notifications.HealthPlanNotifications.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            this.props.getUserAccountSettings();
            this.setState({ shouldLoadData: false });
            console.log("DONE");
        }

        ////if (this.props.getUserAccountSettings !== prevProps.getUserAccountSettings || (this.props.error && this.props.error !== prevProps.error && !this.state.shouldLoadData)) {
        //    console.log("IN", this.props.notificationPreferences);
        //    this.setState({ showLoader: false, shouldLoadData: false });
        //}
    }

    toggleTooltip(name) {
        this.setState(prevState => ({
            [`show${name}Tooltip`]: !get(prevState, `show${name}Tooltip`)
        }));
    }

    onNotificationChange(value, name) {
        this.setState({
            [`is${name}Enabled`]: value
        });
    }

    render () {
        const {userRole} = this.props;
        const {
            showSupportTooltip, showAuthTooltip, showOtherTooltip, isSupportEmailEnabled, isSupportTextEnabled, isAuthEmailEnabled,
            isCertMailEnabled, isCertEmailEnabled, isExpMailEnabled, isExpEmailEnabled, isOthersMailEnabled, isOthersEmailEnabled
        } = this.state;

        return (
            <React.Fragment>
                <div className="row health-plan-notifications">
                    <div className="col-12">
                        <h2 className="page-heading section-heading">{
                            `${userRole === "FirstCare" ? "FirstCare Health Plans" : "Baylor Scott & White Health Plan"}`}
                        </h2>
                    </div>
                </div>

                {this.state.showLoader ?
                    <div id="authorization-detail-spinner" className="spinner">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                    </div>
                    :
                    <div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4">
                                        <div className="list-item-col__label">Support <span className="icon-info" id="lbl-prescriptions" />
                                            <Tooltip placement="top" isOpen={showSupportTooltip} autohide={false} target="lbl-prescriptions" toggle={() => this.toggleTooltip('Support')}>
                                                Receive notifications for your Support inquiry activity.
                                        </Tooltip>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="TEXT" name="textNotifications"
                                            checked={isSupportEmailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'SupportEmail')}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                            checked={isSupportTextEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'SupportText')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4">
                                        <div className="list-item-col__label">Authorization Approval Letter</div>
                                        {/**<div className="list-item-col__label">Authorization Approval Letter <span className="icon-info" id="lbl-auth" />
                                        <Tooltip placement="top" isOpen={showAuthTooltip} autohide={false} target="lbl-auth" toggle={() => this.toggleTooltip('Auth')}>
                                        </Tooltip>
                                    </div>**/}
                                    </div>
                                    <div className="col-12 col-sm-3 text-sm-right" />

                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                            checked={isAuthEmailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'AuthEmail')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 text-left">
                                        <div className="list-item-col__info">Turn off the mail options below to save paper and find what you need in the member portal instead.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4">
                                        <div className="list-item-col__label">Certificate/Evidence of coverage</div></div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="MAIL" name="textNotifications"
                                            checked={isCertMailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'CertMail')}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                            checked={isCertEmailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'CertEmail')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4">
                                        <div className="list-item-col__label">Explanation of benefits</div>
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="MAIL" name="textNotifications"
                                            checked={isExpMailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'ExpMail')}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                            checked={isExpEmailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'ExpEmail')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 list-item-col not-linked">
                                <div className="row">
                                    <div className="col-12 col-sm-4">
                                        <div className="list-item-col__label">Other Communications <span className="icon-info" id="lbl-other" />
                                            <Tooltip placement="top" isOpen={showOtherTooltip} autohide={false} target="lbl-other" toggle={() => this.toggleTooltip('Other')}>
                                                "Other communications" may include but are not limited to communications related to enrollment, disenrollment, appeals, grievances,
                                                mid-year change notifications or notification of errors in previously released documents.
                                        </Tooltip>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="MAIL" name="textNotifications"
                                            checked={isOthersMailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'OthersMail')}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 text-sm-right">
                                        <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                            checked={isOthersEmailEnabled}
                                            onChange={checked => this.onNotificationChange(checked, 'OthersEmail')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            </React.Fragment>            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserAccountSettings: () => dispatch({ type: types.HP_GET_NOTIFICATION_PREFERENCES_START }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthPlanNotifications);
